module.exports = __webpack_public_path__ + "static/logo-2026-f83d447cbafc72a328e037db81ac8693.png";